module.exports = __webpack_public_path__ + "img/phone4.c688b4e3.png";